module.exports = __webpack_public_path__ + "img/denti_i_logo_incheon.3945efaa.png";